// Base URL for every API request. VITE_API_URL is set per environment in the
// repo's GitHub environment variables, and those values end in "/"; trim
// trailing slashes so requests go to ".../api/..." rather than "...//api/...".
export const API_BASE_URL = `${import.meta.env.VITE_API_URL.replace(/\/+$/, '')}/api`;
